import React, { useState } from 'react';
import "./input-review.css"
const CommentInputBox = () => {
    const [comment, setComment] = useState('');
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleSubmit = (event) => {
        event.preventDefault();
        // code to handle submitting the comment and images goes here
        //console.log(comment, images);
    };

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const handleImageChange = (event) => {
        const files = event.target.files;
        const newImages = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const reader = new FileReader();
            reader.onloadend = () => {
                newImages.push(reader.result);
                if (newImages.length === files.length) {
                    setImages([...images, ...newImages]);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleImageRemove = (index) => {
        setImages([...images.slice(0, index), ...images.slice(index + 1)]);
    };

    const handleImageClick = (image) => {
        setSelectedImage(image);
    };

    const handleModalClose = () => {
        setSelectedImage(null);
    };

    const handlePrevClick = () => {
        if (selectedIndex > 0) {
            setSelectedIndex(selectedIndex - 1);
            setSelectedImage(images[selectedIndex - 1]);
        }
    };

    const handleNextClick = () => {
        if (selectedIndex < images.length - 1) {
            setSelectedIndex(selectedIndex + 1);
            setSelectedImage(images[selectedIndex + 1]);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <label className="block text-gray-700 font-bold mb-2" htmlFor="comment">
                Comment:
            </label>
            {/* resize-none */}
            <textarea

                className=" border rounded-md w-full py-2 px-3"
                id="comment"
                name="comment"
                value={comment}
                onChange={handleCommentChange}
            />
            <label className="block text-gray-700 font-bold mb-2" htmlFor="image">
                Upload  Images:
            </label>
            <div className="flex flex-wrap">
                {images.map((image, index) => (
                    <div
                        key={index}
                        className="mr-2 mb-2 relative rounded-md w-16 h-16 overflow-hidden"
                        onClick={() => handleImageClick(image)}
                    >
                        <img
                            src={image}
                            alt={`Selected image ${index + 1}`}
                            className="w-full h-full object-cover"
                        />
                        <button
                            className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                            onClick={() => handleImageRemove(index)}
                        >
                            <span className="text-xs">X</span>
                        </button>
                    </div>
                ))}
                <label
                    className="flex flex-col items-center justify-center border rounded-md w-16 h-16 cursor-pointer hover:bg-gray-200"
                    htmlFor="image"
                >
                    <span className="text-gray-400 text-sm">Add Image</span>
                    <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        id="image"
                        name="image"
                        onChange={handleImageChange}
                        multiple
                    />
                </label>
            </div>
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div className="max-w-3xl mx-auto rounded-md overflow-hidden">
                  <button
                    className="absolute top-0 right-0 mx-4 text-white text-[50px] font-bold hover:text-gray-200 transition-opacity duration-300"
                    onClick={handleModalClose}
                  >
                    X
                  </button>
                  <button
                    className="absolute top-[40vh] left-[10vw] m-4 text-white text-[100px] font-bold hover:text-gray-200 transition-transform duration-500 ease-in-out"
                    onClick={handlePrevClick}
                  >
                    &lt;
                  </button>
                  <img
                    src={selectedImage}
                    alt="Selected image"
                    className="w-full  transition-transform duration-500 ease-in-out"
                    key={selectedImage}
                  />
                  <button
                    className="absolute top-[40vh] right-[10vw] m-4 text-white text-[100px] font-bold hover:text-gray-200 transition-transform duration-500 ease-in-out"
                    onClick={handleNextClick}
                  >
                    &gt;
                  </button>
                </div>
              </div>
              
            )}
            <button className="mt-2 text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded">
                Submit
            </button>
        </form>
    );
};

export default CommentInputBox;


